import React from "react";
import { getAuth, signOut } from "firebase/auth";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch } from "react-redux";
import { setAuth, setToken, setIsAdmin } from "../../actions/auth";

export const signoutHandler = (dispatch, IsAdmin = false) => {
  const auth = getAuth();
  signOut(auth)
    .then(() => {
      dispatch(setAuth(false));
      dispatch(setToken(""));
      window.localStorage.setItem("auth", "false");
      window.localStorage.setItem("token", "");
      if (IsAdmin) {
        dispatch(setIsAdmin(false));
        window.localStorage.setItem("isAdmin", "false");
      }
    })
    .catch((error) => {
      // An error happened.
    });
};
const LogoutButton = () => {
  const dispatch = useDispatch();
  const handleSignOut = (e) => {
    signoutHandler(dispatch, true);
  };

  return (
    <div style={{ textAlign: "right" }}>
      <div data-testid="logout-btn" onClick={handleSignOut}>
        <LogoutIcon color={"error"} />
      </div>
    </div>
  );
};
export default LogoutButton;
